import { gsap } from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import barba from '@barba/core';
import { initHeaderScroll, destroyHeaderScroll } from './headerScroll';
import { initBarba } from './pagetransition';
import mobileMenu from './pagetransition';
import HoverImgFx1 from './workhover';
import TouchImgFx1 from './worktouch';
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

initBarba();

gsap.registerPlugin(ScrollTrigger);

/* Correct Sizing of vh on Mobile - Recalculate When Window Resize */
const setVH = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
setVH();

/* Case Study Details - Set Title Position */
const setCaseStudyDetailsTtitlePos = () => {
    let taglineHeight = document.querySelector('.hero__tagline').offsetHeight + 30;
    const titlePos = document.querySelector('.hero__title');
    const wwIsMobile = window.matchMedia("(max-width: 991px)").matches;
    titlePos.style.bottom = wwIsMobile ? "calc(6% + " + taglineHeight +  "px)" : "9%";
}

/* Case Study Index - Add styles to Case Study Index page */
function caseStudyIndexStyle() {
    console.log('Case study page');
    const paragraphs = document.querySelectorAll("#tagline");

    paragraphs.forEach(paragraph => {
        const lines = paragraph.innerHTML.split(/<br\s*\/?>/);
        paragraph.innerHTML = lines.map(line => `<span class="animated-line">${line}</span>`).join('<br/>');

        const item = paragraph.closest(".casestudy.item");
        const video = item?.querySelector("video");

        ScrollTrigger.create({
            scroller: ".casestudyWrapper",
            trigger: paragraph,
            start: "top 80%",
            end: "bottom 50%",
            toggleActions: "play none none none",

            onEnter: () => {
                console.log("Block in view:", paragraph);

                // Animate lines with 'show' class
                paragraph.querySelectorAll(".animated-line").forEach((line, index) => {
                    setTimeout(() => {
                        line.classList.add("show");
                    }, index * 300);
                });

                // Animate video (slight zoom-in and move up)
                if (video) {
                    gsap.fromTo(video, 
                        { scale: 0.8, y: -10 },
                        { scale: 1, y: 0, duration: 1.2, ease: "power3.out" }
                    );
                }
            },

            onLeaveBack: () => {
                console.log("Block scrolled back out:", paragraph);

                // Remove 'show' classes to reset underline
                paragraph.querySelectorAll(".animated-line").forEach(line => {
                    line.classList.remove("show");
                });

                // Reset video transform
                if (video) {
                    gsap.to(video, {
                        scale: 0.8,
                        y: -10,
                        duration: 0.8,
                        ease: "power2.inOut"
                    });
                }
            }
        });
    });
}

function caseStudyIndexNav() {
    console.log('Case study page - bulding nav v3');
    setTimeout(() => {
        console.log("Initializing case study navigation...");

        const wrapper = document.querySelector(".casestudyWrapper");
        const items = Array.from(document.querySelectorAll(".casestudy.item"));
        const btnUp = document.getElementById("arrowUp");
        const btnDown = document.getElementById("arrowDown");

        if (!wrapper || items.length === 0 || !btnUp || !btnDown) {
            console.warn("caseStudyIndexNav: Required elements not found.");
            return;
        }

        let currentIndex = 0;

        function scrollToItem(index) {
            if (index < 0) index = items.length - 1;
            if (index >= items.length) index = 0;

            let target = items[index];
            wrapper.scrollTo({
                top: target.offsetTop,
                behavior: "smooth"
            });

            currentIndex = index;
        }

        // Remove previous click handlers to avoid duplication
        btnUp.onclick = null;
        btnDown.onclick = null;

        btnUp.onclick = () => scrollToItem(currentIndex - 1);
        btnDown.onclick = () => scrollToItem(currentIndex + 1);
    }, 100);
}

/* Work Index - Initiate Hover Effects */
function initWorkHoverEffects() {
    if ("ontouchstart" in document.documentElement) {
        if (document.querySelector(".workMenu")) {
            document.querySelector(".workMenu").classList.add('touch');
            [...document.querySelectorAll('[data-fx="1"] .view')].forEach(link => new TouchImgFx1(link));
        }
    } else {
        if (document.querySelector(".workMenu")) {
            [...document.querySelectorAll('[data-fx="1"] .workMenu__item')].forEach(link => new HoverImgFx1(link));
        }
    }
}

// Work Index - Re-run after Search and Filter Pro AJAX updates
if (window.searchAndFilter) {
    const queryId = 1; // Query ID.
    const query = window.searchAndFilter.frontend.queries.get( queryId );
    if ( query ) {
        // Only hook in to the update if dynamic update is enabled for the query.
        if ( query.getAttribute('resultsDynamicUpdate') === 'yes' ) {
            // Listen for the update to the results.
            query.on( 'get-results/start', function (queryObject) {
                console.log("Start getting results.");
            } );

            // Listen for the update to the results.
            query.on( 'get-results/finish', function (queryObject) {
                console.log("Finished getting results.");
                const filterFields = document.getElementById("filterFields");
                filterFields.classList.toggle("show");
                bindBtnFilterClick();
                // updateFilterButtonText();
                initWorkHoverEffects();
                enterWorkListAnimation(document);
            } );
        }
    }
}

/* Work Index -  Enter Work Index Page Animation: Show Belief */
const showBelief = () => {
    const belief = document.querySelector('.belief');
    const tl = gsap.timeline({
        defaults: {
            ease: 'expo.inOut',
            duration: 1.5
        }
    });
    tl.to(belief, {
        autoAlpha: 1
    }, 0).from(belief, {
        x: -100
    }, 0).to(belief, {
        autoAlpha: 0,
        //x:50,
        delay:0.5,
        duration:1.5
    }, 2);

    return tl;
}

/* Work Index -  Enter Work Index Page Animation: The List */
const enterWorkListAnimation = (container) => {
    const select = (elem) => container.querySelector(elem);
    const selectAll = (elem) => [...container.querySelectorAll(elem)];
    // const workList = select('.workList');
    const workItems = selectAll('.workMenu__item');
    const workMenu = select('.workMenu');
    const tl = gsap.timeline({
        defaults: {
            ease: 'expo.inOut',
            duration: 0.8
        }
    });
    tl.to(workMenu, {
        autoAlpha: 1,
        y:0
    }, 0);

    if ("ontouchstart" in document.documentElement) {
        workMenu.classList.add('touch');
    }
    return tl;
}

/* Work Index -  Bind Filter Button Click */
function bindBtnFilterClick() {
    const btnFilter = document.getElementById("btnFilter");
    const filterFields = document.getElementById("filterFields");
  
    if (btnFilter && filterFields) {
      // Replace the button to remove any previous event listeners
      const newBtn = btnFilter.cloneNode(true);
      btnFilter.parentNode.replaceChild(newBtn, btnFilter);
  
      // Now query spans from the **new button**
      const textShow = newBtn.querySelector(".textShowFilters");
      const textHide = newBtn.querySelector(".textHideFilters");
      const icon = newBtn.querySelector(".icon");
  
      if (textShow && textHide) {
        const updateButtonText = () => {
          if (filterFields.classList.contains("show")) {
            textShow.style.display = "none";
            textHide.style.display = "inline";
            icon.classList.add("hide");
          } else {
            textShow.style.display = "inline";
            textHide.style.display = "none";
            icon.classList.remove("hide");
          }
        };
  
        newBtn.addEventListener("click", function () {
          filterFields.classList.toggle("show");
          updateButtonText();
        });
  
        // Sync initial text state
        updateButtonText();

        // Bind click on .filteredResult to always show filters
        document.querySelectorAll(".filteredResult").forEach(item => {
            item.addEventListener("click", () => {
            if (!filterFields.classList.contains("show")) {
                filterFields.classList.add("show");
                updateButtonText();
            }
            });
        });
      }
    }
}
  
/* Work or Case Study Details -  Embed Fullscreen Vimeo Video (MP4) */
let plyrInstances = [];

function resetToPreview(wrapper) {
    const previewVideo = wrapper.dataset.previewVideo;
    const fallbackImg = wrapper.dataset.fallbackImg;
  
    let content = '';
  
    if (previewVideo) {
      content = `
        <video class="video-preview" autoplay muted loop playsinline>
          <source src="${previewVideo}" type="video/mp4">
        </video>`;
    } else if (fallbackImg) {
      content = `<img class="preview-image" src="${fallbackImg}" alt="Preview">`;
    }
  
    // Re-add custom play button
    content += `<button class="btnPlayCustom" aria-label="Play video"></button>`;
  
    wrapper.innerHTML = content;
    wrapper.classList.remove('is-loaded', 'is-playing');
  }
  
/* Vimeo - Switch from vimeo to plyr */
function initVideoBlocks() {
  const wrappers = document.querySelectorAll('.csWrap__mp4Wrapper');

  // Destroy old Plyr instances
  plyrInstances.forEach(p => p.destroy());
  plyrInstances = [];

  wrappers.forEach((wrapper, index) => {
    if (wrapper.classList.contains('is-initialized')) return;

    wrapper.classList.add('is-initialized');

    const playBtn = wrapper.querySelector('.btnPlayCustom');

    wrapper.addEventListener('click', () => {
      if (wrapper.classList.contains('is-playing')) return;

      // Reset all others
      document.querySelectorAll('.csWrap__mp4Wrapper').forEach((w, i) => {
        if (i !== index) resetToPreview(w);
      });

      const mp4Url = wrapper.dataset.videoUrl;

      const videoEl = document.createElement('video');
      videoEl.setAttribute('playsinline', '');
      videoEl.setAttribute('controls', '');
      videoEl.setAttribute('autoplay', '');
      videoEl.setAttribute('preload', 'auto');
      videoEl.classList.add('main-video');

      const source = document.createElement('source');
      source.setAttribute('src', mp4Url);
      source.setAttribute('type', 'video/mp4');
      videoEl.appendChild(source);

      wrapper.innerHTML = '';
      wrapper.appendChild(videoEl);

      // Add spinner while video loads
      const spinner = document.createElement('div');
      spinner.classList.add('plyr-loading-spinner');
      wrapper.appendChild(spinner);

      wrapper.classList.add('is-loaded', 'is-playing');

      // Ensure the video is attached to DOM before Plyr init
      setTimeout(() => {
        // const player = new Plyr(videoEl, {
        //   controls: ['play', 'progress', 'mute', 'volume', 'fullscreen'],
        // });

        // Fix for iOS fullscreen issue by enabling fallback and iosNative options
        const player = new Plyr(videoEl, {
            controls: ['play', 'progress', 'mute', 'volume', 'fullscreen'],
            fullscreen: {
                enabled: true,
                fallback: true,
                iosNative: true
            }
        });

        plyrInstances.push(player);

        player.once('canplay', () => {
          // Remove spinner once video is ready
          spinner.remove();
          player.play().catch(err => {
            console.warn('Autoplay failed:', err);
          });
        });

        player.on('ended', () => {
          resetToPreview(wrapper);
        });
      }, 100); // small delay ensures DOM update
    });
  });
}

/* Add 'tc' class to <main> and initialize case study functions */
function initPageFeatures(path) {
    const mainTag = document.querySelector('main');

    if (!mainTag) return;

    // Normalize path (remove trailing slash if not just "/")
    if (path !== '/' && path.endsWith('/')) {
        path = path.slice(0, -1);
    }

    // Remove existing language classes
    mainTag.classList.remove('tc');

    // Add 'tc' class based on path
    if (path.includes('/tc')) {
        mainTag.classList.add('tc');
        console.log("✅ Added 'tc' class to main");
    }

    // Case study logic
    if (path === '/case-study' || path === '/tc/case-study') {
        caseStudyIndexStyle();
        caseStudyIndexNav();
    }
}

/* DOM Content Loaded */
document.addEventListener('DOMContentLoaded', () => {
    initWorkHoverEffects(); // Initialize work hover effects on initial load
    bindBtnFilterClick(); // Bind filter button click on initial load
    initVideoBlocks(); // Initialize video blocks on initial load

    requestAnimationFrame(() => {
        let path = window.location.pathname.replace(/\/$/, '');
        initPageFeatures(path);
    });

    if (document.body.classList.contains('page-work-index')) {
        enterWorkListAnimation(document);
        showBelief();
        mobileMenu(document);
        initHeaderScroll('work-index');
    }

    // let pageCache = {};
    // let cacheTimestamps = {};
    if (typeof barba !== 'undefined') {
        // barba.hooks.enter((data) => {
        //     let url = data.next.url.path; // Get the next page URL
        //     let now = Date.now();
        
        //     // Check if page is in cache and not expired (300,000 ms = 5 min)
        //     if (pageCache[url] && now - cacheTimestamps[url] < 300000) {
        //         console.log(`✅ Page loaded from cache: ${url}`);
        //         data.next.container.innerHTML = pageCache[url];
        //     } else {
        //         console.log(`🔄 Fetching new page: ${url}`);
        //         pageCache[url] = data.next.container.innerHTML;
        //         cacheTimestamps[url] = now; // Save timestamp
        //     }
        // });
        barba.hooks.afterEnter((data) => {
            console.log("Entering page:", data.next.url.path);
            
            // Wait for a short delay to ensure the new content is processed
            requestAnimationFrame(() => {
                let path = data.next.url.path;
                initPageFeatures(path);
            });

            // To ensure autoplay videos work after page transition, we need to re-trigger play on any video elements with autoplay attribute
            const videos = document.querySelectorAll('video[autoplay]');
  
            videos.forEach(video => {
                video.muted = true; // ensure autoplay policy passes
                video.play().catch(err => {
                    console.log('Autoplay blocked:', err);
                });
            });

            // Give Barba time to fully swap DOM before attaching scroll listener
            setTimeout(() => {
                initHeaderScroll(data.next.namespace);
            }, 100);
        });
        barba.hooks.after(() => {
            initVideoBlocks(); // Reinitialize video blocks
        });
        barba.hooks.afterOnce((data) => {
            setTimeout(() => {
                initHeaderScroll(data.next.namespace);
            }, 100);
        });
        
    } else {
        console.log('Barba.js is not defined');
    }
});

/* Window Resize */
window.addEventListener('resize', (event) => { 
    setVH();

    /* Get barba namespace */
    const main = document.getElementsByTagName('main');
    const barbaNS = main[0].getAttribute('data-barba-namespace');

    /* Only run this on case study details */
    if(barbaNS == 'casestudydetails'){
        setCaseStudyDetailsTtitlePos();
    }
});